import React from 'react';
import { Facebook, Twitter, Dribble } from '../icons';
var productColumn = {
  name: 'Product',
  links: [{
    name: 'Enterprise',
    link: 'https://www.frame.io/enterprise'
  }, {
    name: 'Developers',
    link: 'https://developer.frame.io'
  }, {
    name: 'Apps',
    link: 'https://www.frame.io/apps'
  }, {
    name: 'Pricing',
    link: 'https://www.frame.io/pricing'
  }, {
    name: 'Customers',
    link: 'https://www.frame.io/customers'
  }, {
    name: 'Security',
    link: 'https://www.frame.io/security'
  }, {
    name: 'Transfer',
    link: 'https://www.frame.io/transfer'
  }, {
    name: 'HDR',
    link: 'https://www.frame.io/hdr'
  }]
};
var integrationsColumn = {
  name: 'Integrations',
  links: [{
    name: 'Watch Folders',
    link: 'https://www.frame.io/watch-folders'
  }, {
    name: 'Final Cut Pro',
    link: 'https://www.frame.io/fcpx'
  }, {
    name: 'Premiere Pro',
    link: 'https://www.frame.io/premiere'
  }, {
    name: 'After Effects',
    link: 'https://www.frame.io/after-effects'
  }, {
    name: 'DaVinci Resolve',
    link: 'https://blog.frame.io/2019/04/08/davinci-resolve-in-frameio'
  }, {
    name: 'Slack',
    link: 'https://blog.frame.io/2016/08/17/introducing-frame-io-slack/'
  }, {
    name: 'Zapier',
    link: 'https://zapier.com/apps/frameio/integrations'
  }]
};
var companyColumn = {
  name: 'Company',
  links: [{
    name: 'Careers',
    link: 'https://careers.frame.io'
  }, {
    name: 'Blog',
    link: 'https://blog.frame.io'
  }, {
    name: 'Press',
    link: 'https://www.frame.io/press'
  }, {
    name: 'Swag Store',
    link: 'https://shop.frame.io'
  }]
};
var supportColumn = {
  name: 'Support',
  links: [{
    name: 'Support',
    link: 'https://support.frame.io'
  }, {
    name: 'Contact Us',
    link: 'mailto:support@frame.io'
  }, {
    name: 'Status Page',
    link: 'https://status.frame.io'
  }]
};
var socialLinks = [{
  name: 'Facebook',
  link: 'https://www.facebook.com/frameioapp',
  icon: /*#__PURE__*/React.createElement(Facebook, null)
}, {
  name: 'Twitter',
  link: 'https://twitter.com/Frame_io',
  icon: /*#__PURE__*/React.createElement(Twitter, null)
}, {
  name: 'Dribble',
  link: 'https://dribbble.com/frameio',
  icon: /*#__PURE__*/React.createElement(Dribble, null)
}];
var allFootercolumns = [productColumn, integrationsColumn, companyColumn, supportColumn];
export { allFootercolumns, socialLinks };